import { render, staticRenderFns } from "./documentCompassCopy.vue?vue&type=template&id=1f9b1c81&scoped=true&"
import script from "./documentCompassCopy.vue?vue&type=script&lang=js&"
export * from "./documentCompassCopy.vue?vue&type=script&lang=js&"
import style0 from "./documentCompassCopy.vue?vue&type=style&index=0&id=1f9b1c81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b1c81",
  null
  
)

export default component.exports